import React, { Component } from "react";
import Modal from "react-modal";
import Draggable from 'react-draggable';
import { message,Spin } from 'antd';
import HTMLReactParser from 'html-react-parser';
import AuthenticationService from './../service/authentication_service';
import SockJsClient from 'react-stomp';
import AppService from "../service/app_service";
import UrlService from '../service/url_service'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';


class ChatOnly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hello: "hello",
      showSetPriceDialog: false,
      rate: props.rate,
      amount: props.amount,
      messages: [],
      chatData: props.chatData,
      isTourOpen: false,
      selectedFile: null,
      photoIndex: 0,
      isOpen: false,
      activeDrags: 0,
      deltaPosition: {
        x: 0, y: 0
      },
      controlledPosition: {
        x: -400, y: 200
      },
      history: false,
      loading: false,
    };
    this.inputOpenFileRef = React.createRef()
    this.inputTextareaRef = React.createRef()
  }

  componentDidMount() {
    setTimeout(() => {

      this.scrollDown();

      Modal.setAppElement("#root");
    }, 100);

  }

  

  scrollDown = () => {
    let shoppingListContainer = document.getElementById("chat-body");
    if (shoppingListContainer)
      shoppingListContainer.scrollTop = shoppingListContainer.scrollHeight;
  }

  handlePriceChange = (event) => {
    const { id, value } = event.target;
    this.setState({
      [id]: value,
    });
  };

  updatePrice = (event) => {
    event.preventDefault();
    this.setState({
      showSetPriceDialog: false,
    });
  };

  viewHistory = () => {
    this.setState({
      history: !this.state.history,
    });
  };


  toggleModal = () => {
    this.setState({
      showSetPriceDialog: !this.state.showSetPriceDialog,
    });
    this.props.close();
  };



  handleDrag = (e, ui) => {
    const { x, y } = this.state.deltaPosition;
    this.setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      }
    });
  };

  onStart = () => {
    this.setState({ activeDrags: ++this.state.activeDrags });
  };

  onStop = () => {
    this.setState({ activeDrags: --this.state.activeDrags });
  };

  // For controlled component
  adjustXPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { x, y } = this.state.controlledPosition;
    this.setState({ controlledPosition: { x: x - 10, y } });
  };

  adjustYPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { controlledPosition } = this.state;
    const { x, y } = controlledPosition;
    this.setState({ controlledPosition: { x, y: y - 10 } });
  };

  onControlledDrag = (e, position) => {
    const { x, y } = position;
    this.setState({ controlledPosition: { x, y } });
  };

  onControlledDragStop = (e, position) => {
    this.onControlledDrag(e, position);
    this.onStop();
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  onEnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      this.sendMessage();
    }
  }

  submitMessage = () => {
    this.sendMessage();
  }

  sendMessage = () => {
    if(this.state.message){
      const { chatData } = this.state;
      let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
      let data = {};
      data.name = AuthenticationService.getName();
      data.message = this.state.message;
      data.xo = AuthenticationService.getToken();
      data.channel = channel;
      data.requestId = chatData.id;
      this.clientRef.sendMessage('/app/chat', JSON.stringify(data));
      this.setState({
        message: '',loading: true,
      });
    }
    
    //this.inputTextareaRef.focus();
  };

  sellInitiation = (amt, rate) => {
    const { chatData } = this.state;
    let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
    let data = {};
    data.amount = amt;
    data.rate = rate && rate > 0 ? rate : 1;
    data.xo = AuthenticationService.getToken();
    data.channel = channel;
    data.requestId = chatData.id;
    this.clientRef.sendMessage('/app/sell/time', JSON.stringify(data));
    this.setState({
      message: '',loading: true,
    });
  };

  balanceEnquiry = (amt, rate) => {
    const { chatData } = this.state;
    let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
    let data = {};
    data.amount = amt;
    data.rate = rate && rate > 0 ? rate : 1;
    data.xo = AuthenticationService.getToken();
    data.channel = channel;
    data.requestId = chatData.id;
    this.clientRef.sendMessage('/app/check/balance', JSON.stringify(data));
    this.setState({
      message: '',loading: true,
    });
  };

  setIsTourOpen = (status) => {
    this.setState({
      isTourOpen: status,
    });
  }

  handleClickFile(type) {
    this.setState({
      uploadAction: type,
    }, () => {

      this.inputOpenFileRef.current.click()
    })

  }

  onChangeHandler = event => {

    console.log(event.target.files[0]);
    this.setState({
      selectedFile: event.target.files[0],
    })
    let data = {
      upload: event.target.files[0]
    }
    AppService.uploadonly(data)
      .then(response => {

        if (response.code) {

        } else {
          this.setState({ uploading: false })
          console.log(response);
          const img = "http://localhost:8050/apps/" + response.documentName;

          const { chatData } = this.state;
          let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
          let data = {};
          data.name = AuthenticationService.getName();
          data.message = response.documentName; // "<img src='" + img + "'  width='200' />";
          data.xo = AuthenticationService.getToken();
          data.type = "IMAGE";
          data.channel = channel;
          data.amount = this.state.amount;
          data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
          data.requestId = chatData.id;
          this.clientRef.sendMessage('/app/' + this.state.uploadAction, JSON.stringify(data));
          this.setState({
            message: '',
          });
        }

      })

  }

  handoverConfirmation = () => {
    const { chatData } = this.state;
    let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
    let data = {};
    data.amount = this.state.amount;
    data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
    data.requestId = chatData.id;
    data.xo = AuthenticationService.getToken();
    data.channel = channel;
    this.clientRef.sendMessage('/app/handover/confirmation', JSON.stringify(data));
    this.setState({
      message: '',loading: true,
    });
  };

  showImage = (img) => {
    console.log("showimage")
    this.setState({ isOpen: true, img: img })
  }

  render() {


    const { chatData, amount, rate, messages, isTourOpen, photoIndex, isOpen, img, thread } = this.state;
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    let channel = (chatData && chatData.channel) ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;

    AuthenticationService.setChannel(channel);
    const imgbase = UrlService.BASE_PATH+"/xchange/attachments/";

    let chats = messages && messages.map((item, i) => {
      let c = item.mobileNumber === "COMPUTER" ? "comp" : item.mobileNumber !== AuthenticationService.getMobileNumber() ? "sent" : "received";
      return <div className={"message " + c} key={i} onClick={() => item.type === "IMAGE" ? this.showImage(imgbase + item.message) : ''} >
        <div id="random" >
          {item.type === "IMAGE" ? <a target="_blank" style={{ zIndex: '-111', pointerEvents: 'auto' }} > <img src={imgbase + item.message} width='200' /> </a> : item.type === "LINK" ? <a href={item.message}>Click Here</a> : HTMLReactParser(item.message)}
        </div>
        <span className="metadata"><span className="time" />{isOpen}</span>
      </div>
    });

    const images = [
      img
    ];


    let chatBody = <div id="whatsapp-chat" className="show">
      

      <div className="header-chat">
        <div className="head-home">
          <div className="info-avatar" >
            {/* <img src="https://tradexsafely.com/web/assets/img/Icon.png" width={150} /> */}
          </div>
          <p>
            <span className="whatsapp-name">Asset:{chatData.asset}</span><br /><small>{chatData.createdAt}</small>
           
          </p>
          {/* <div style={{ width: '100%' }}>
            <p style={{ fontSize: '10px' }}>Upload payment evidence</p>
          </div> */}



        </div>
        <div className="get-new hide">
          <div id="get-label" />
          <div id="get-nama" />
        </div>
      </div>
      <div className="home-chat">


      </div>
      <div className="start-chat" id="start-chat">
        <div className="chat-body" id="chat-body">


          <div className="chat-container">

            <div className="conversation">
              <div className="conversation-container">

                {/* {this.state.loading  ? <Spin size="large" spinning={this.state.loading} />
                    : chats} */}
                {chats}


              </div>
            </div>
          </div>




        </div>

        <div className="blanter-msg">
          <textarea id="chat-input" name="message" ref={this.inputTextareaRef} onChange={this.handleChange} style={{ height: '40px' }} placeholder="Write a response" maxLength={120} row={1} value={this.state.message} onKeyDown={this.onEnterPress} />
          <a onClick={() => this.submitMessage()} id="send-it"><svg viewBox="0 0 448 448"><path d="M.213 32L0 181.333 320 224 0 266.667.213 416 448 224z" /></svg></a>
        </div>
      </div>
      <div id="get-number" /><a className="close-chat" onClick={() => {
        this.props.close();
      }} >×</a>
    </div>;

    
    return (
      <div>


        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}



        {window.innerWidth > 1366 ? <Draggable cancel=".comp" {...dragHandlers}>
          {chatBody}
        </Draggable> : chatBody}
        


        <SockJsClient url={UrlService.BASE_PATH+'/unified/'}
          topics={['/queue/chat/' + channel]}
          onConnect={() => {
            console.log("connected");
            let data = {};
            data.channel = channel;
            this.setState({ loading: true });
            if(this.clientRef)
              this.clientRef.sendMessage('/app/chat/messages', JSON.stringify(data));
          }}
          onDisconnect={() => {
            console.log("Disconnected");
          }}
          onMessage={(msg) => {
            console.log(msg)

            if (msg.action === "CHAT_MESSAGES") {
              var thread = msg.thread ? msg.thread : this.state.thread;
              this.setState({ messages: msg.messages, thread: thread, loading: false });
              this.scrollDown();
            } else if (msg.action === "NEGOTIATION") {
              var thread = msg.thread ? msg.thread : this.state.thread;
              var jobs = this.state.messages;
              jobs.push(msg);
              this.setState({ messages: jobs, rate: msg.rate, amount: msg.amount, thread: thread, loading: false });
              this.scrollDown();
            } else {
              var thread = msg.thread ? msg.thread : this.state.thread;
              var jobs = this.state.messages;
              jobs.push(msg);
              this.setState({ messages: jobs, thread: thread, loading: false });
              this.scrollDown();
            }

            // console.log(this.state);
          }}
          ref={(client) => {
            this.clientRef = client
          }} />



      </div>
    );
  }
}

export default ChatOnly;
